<!-- <app-cam-toaster></app-cam-toaster> -->
<section class="section-wrapper">
    <h2 class="cam-heading">{{content?.['b2b.managecompany.companymanagement']}}</h2>
    <div class="section-context">
        <div class="menu-left-content">
            <app-menu-nav-expanded></app-menu-nav-expanded>
        </div>
        <div class="right-content">
            <ng-container *ngIf="renderer">
                <router-outlet></router-outlet>
            </ng-container>
        </div>
    </div>
</section>